import React from 'react';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';

import useSession from 'core/hooks/use-session';
import { useStore } from 'core/store/store.mobx';
import { MyCommunity } from '../my-community';
import { Pledges } from '../pledges';
import AdditionalOffers from '../additional-offers';
import { MicroDeposits } from '../micro-deposits';
import { AccountDetails } from '../account-details';
import { AgentDetails } from '../agent-details';
import useStyles from './sidebar.styles';

const CustomerSidebar = observer((props) => {
  const {
    account,
    affinityLookups,
    account: {
      policies,
      policies: { achPolicies }
    }
  } = useStore();
  const recentPolicy = policies.getRecentPolicy();

  const customerAffinityCode = recentPolicy?.segments?.[0]?.global.affinity;
  const affinityData = affinityLookups.data.find(({ affinity }) => affinity === customerAffinityCode);

  const isAgentSold = customerAffinityCode && affinityData?.isAgency;
  const classes = useStyles();
  const { isAgency, isExternalSales, canEditPolicies } = useSession();
  return (
    <Grid container>
      <Grid item className={classes.bottomSpacing}>
        <AccountDetails {...props} />
      </Grid>
      {canEditPolicies && !!achPolicies.length && account.id === props.accountId && (
        <>
          {achPolicies?.map((policy) => {
            return (
              <Grid item key={`${policy.id}-microdeposits-grid`} className={classes.bottomSpacing}>
                <MicroDeposits
                  key={`${policy.id}-microdeposits`}
                  stripeCustomerId={policy.stripeCustomerId}
                  policyId={policy.id}
                  {...props}
                />
              </Grid>
            );
          })}
        </>
      )}
      <Grid item className={classes.gridItem}>
        <AgentDetails {...props} />
      </Grid>
      <Grid item className={classes.gridItem}>
        <MyCommunity {...props} />
      </Grid>
      <Grid item className={classes.gridItem}>
        <Pledges {...props} />
      </Grid>
      {!isAgentSold && !isAgency && !isExternalSales && canEditPolicies && (
        <Grid item className={classes.gridItem}>
          <AdditionalOffers />
        </Grid>
      )}
    </Grid>
  );
});

export default CustomerSidebar;
